const XOGalleries = [];
window.addEventListener('DOMContentLoaded',function(){
  const allTabsHeader = document.querySelectorAll(".store-btn");
  if (allTabsHeader.length > 0) {
    for (let i = 0; i < allTabsHeader.length; i++) {
      allTabsHeader[i].addEventListener("click", function() {
        setTimeout(() => {
          for(let i = 0; i < XOGalleries.length; i++) {
            XOGalleries[i].forceResize();
          }
        }, 100);
      });

    }
  }
});